var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTimeTravelIcon = function SvgTimeTravelIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.173 0v2.428a9.61 9.61 0 0 1 8.372 10.72c-.553 4.374-3.994 7.847-8.372 8.364v2.404c6.616-.661 11.428-6.526 10.766-13.136C23.398 5.072 18.863.565 13.173 0m-2.406.036A11.83 11.83 0 0 0 4.355 2.68l1.72 1.779a9.6 9.6 0 0 1 4.692-2.02zM2.659 4.375C1.143 6.2.24 8.425 0 10.78h2.406a9.63 9.63 0 0 1 1.973-4.687zM.012 13.184a12.06 12.06 0 0 0 2.659 6.405l1.708-1.718a9.6 9.6 0 0 1-1.961-4.687zm6.063 6.453-1.72 1.647A12.03 12.03 0 0 0 10.767 24v-2.404a9.63 9.63 0 0 1-4.692-1.959m6.496-13.664v6.31l5.413 3.208-.902 1.478-6.315-3.785V5.973z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeTravelIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;